// js
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import RecommendationChart from './RecommendationChart';


class Recommendation extends Component {

  constructor(props) {
    super(props);
  }

  filterKeyGoals(goals) {
    return goals.filter((goal) => goal.isKeyGoal === true);
  }

  render() {
    const { area, goals, groups, values, type } = this.props.areaWithGoals;
    const keyGoalsOnly = this.filterKeyGoals(goals, this.props.dsaGoals);

    return (
      <div className='analytics__recommendation-pptx'>
        <h4>{area.title}</h4>
        <div className='chart'>
          { keyGoalsOnly.length > 0 ? <RecommendationChart analysisGoals={keyGoalsOnly} groups={groups} values={values} type={type} /> : <h4 className='chart__headline'>There are no key goals in this area.</h4> }
        </div>
      </div>
    );
  }
}

Recommendation.propTypes = {
  areaWithGoals: PropTypes.object,
  dsaGoals: PropTypes.object
};

export default Recommendation;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/Recommendation.js